<template>
  <block-notification-fi
    v-if="fields.systemPartnerHint?.value || fields.systemPartnerHint?.editable"
    class="system-partner-hint-fi"
    type="warn"
    icon="alert-triangle"
    data-test="system-partner-hint"
  >
    <richtext-fi field-name="systemPartnerHint" />
  </block-notification-fi>
</template>

<script setup lang="ts">
import { RichtextFi } from 'atoms';

import BlockNotificationFi from '@/components/notifications-fi/block-notification-fi/BlockNotificationFi.vue';
import { useFields } from '@/composables/fields';
import type { RichTextField } from '@/sitecoreFieldTypes';

defineOptions({ name: 'SystemPartnerHintFi' });

const fields = useFields<{
  systemPartnerHint: RichTextField;
}>();
</script>
